import React, { useState } from 'react';
import DestinationsHero from '../components/Destinations/DestinationsHero';
import DestinationsGrid from '../components/Destinations/DestinationsGrid';
import './DestinationsPage.css';

function DestinationsPage() {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'All Destinations' },
    { id: 'national-park', name: 'National Parks' },
    { id: 'beach', name: 'Beach' },
    { id: 'mountain', name: 'Mountains' }
  ];

  return (
    <div className="destinations-page">
      <DestinationsHero 
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
      />
      <div className="destinations-content">
        <div className="destinations-filters">
          <div className="filter-categories">
            {categories.map((category) => (
              <button
                key={category.id}
                className={`filter-btn ${selectedCategory === category.id ? 'active' : ''}`}
                onClick={() => setSelectedCategory(category.id)}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>
        <DestinationsGrid 
          searchQuery={searchQuery}
          selectedCategory={selectedCategory}
        />
      </div>
    </div>
  );
}

export default DestinationsPage;

